import PredicateCandidateParametersPanel from "./PredicateCandidateParametersPanel";
import { filterCandidates } from "../../utils/searchResults";

const PredicateCandidatesTable = ({ 
    searchResults,
    setSearchResults,
    setShowPredicateBubbleMap,
    setShowPredicateCandidates, 
    setShowCustomerReport 
}) => {

    const handleShowCustomerReport = () => {
        setShowPredicateCandidates(false);
        setShowCustomerReport(true);
    }

    const handleBackToBubbleMap = () => {
        setShowPredicateCandidates(false);
        setShowPredicateBubbleMap(true);
    }

    const handleRemoveCandidate = (e, candidate) => {
        // remove the candidate DOM node immediately
        const column = e.currentTarget.closest(".predicate-candidate-column");
        if (column) column.remove();
        
        //TODO: Consider this for the future MG 20251022
        // also emit an event so a parent component can listen and update its state if desired
        // Parent can listen with: window.addEventListener('predicateCandidateRemoved', (ev) => { ... })
        // try {
        //     window.dispatchEvent(
        //         new CustomEvent("predicateCandidateRemoved", { detail: candidate })
        //     );
        // } catch (err) {
        //     console.warn("Could not dispatch predicateCandidateRemoved event", err);
        // }
    };

    const predicateCandidates = filterCandidates(searchResults);

    return (
        <div id="predicate-candidates-table-panel">
            <div className="feature-content-heading">Predicate Candidates Table</div>
            <div className="predicate-bubble-map-button-bar">
              <button
                  type="button"
                  className="predicate-bubble-map-button"
                  onClick={handleBackToBubbleMap}
                  onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "var(--ACCELIDEA_MID_GREEN, #038C5A)")
                  }
                  onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "var(--ACCELIDEA_DARK_GREEN, #025131)")
                  }
              >
                  Back to Bubble Map
              </button>
                <button
                    type="button"
                    className="predicate-bubble-map-button"
                    onClick={handleShowCustomerReport}
                    onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "var(--ACCELIDEA_MID_GREEN, #038C5A)")
                    }
                    onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "var(--ACCELIDEA_DARK_GREEN, #025131)")
                    }
                >
                    View Customer Report
                </button>
            </div>
            <div className="predicate-candidates-table-list">
                {predicateCandidates.map((candidate, idx) => (
                    <div className="predicate-candidate-column" key={candidate.id ?? idx}>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button
                                type="button"
                                aria-label="Remove candidate"
                                title="Remove candidate"
                                onClick={(e) => handleRemoveCandidate(e, candidate)}
                                style={{
                                    background: "transparent",
                                    border: "none",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                }}
                            >
                                ✕
                            </button>
                        </div>
                        <PredicateCandidateParametersPanel 
                            fields={[
                                { name: "deviceName", label: "Device Name", value: candidate.deviceName, height: "100px" },
                                { name: "intendedUse", label: "Intended Use", value: candidate.intendedUse, height: "120px", type: "textarea" },
                                ...(candidate.characteristics && candidate.characteristics.length
                                    ? candidate.characteristics.map((char) => ({
                                        name: char.name,
                                        label: char.name,
                                        value: char.value,
                                    }))
                                    : []),
                            ]}
                            isCandidate={candidate.isCandidate}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PredicateCandidatesTable;